'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

function isString(value) {
    return typeof value === 'string';
}

exports.isString = isString;
